import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { FINCEN_FILE_BASE_PATH } from '../../../../../../../../../features/watchlist/fincen/file/fincen-file-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/file/_file')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'fincen-file-list',
        label: 'FinCEN',
        to: FINCEN_FILE_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
